import { BrowserRouter } from 'react-router-dom';
import { SessionProvider } from './context/SessionContext';
import Layout from './components/Layout/Layout';
import AppRoutes from './routes/AppRoutes';

export default function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Layout>
          <AppRoutes />
        </Layout>
      </SessionProvider>
    </BrowserRouter>
  );
}
